import {
  useFormField
} from "../__chunks/5QHNNZNE.js";
import {
  FormContext
} from "../__chunks/P3I4MECH.js";
import "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import {
  useFocusable
} from "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/NQJBHION.js";
import {
  useEvent
} from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/form/form-input.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useFormInput = createHook(
  (_a) => {
    var _b = _a, { store, name: nameProp } = _b, props = __objRest(_b, ["store", "name"]);
    const context = useContext(FormContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component"
    );
    const name = `${nameProp}`;
    const onChangeProp = props.onChange;
    const onChange = useEvent((event) => {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented)
        return;
      store == null ? void 0 : store.setValue(name, event.target.value);
    });
    const value = store.useValue(name);
    props = __spreadProps(__spreadValues({
      value
    }, props), {
      onChange
    });
    props = useFocusable(props);
    props = useFormField(__spreadValues({ store, name }, props));
    return props;
  }
);
var FormInput = createMemoComponent((props) => {
  const htmlProps = useFormInput(props);
  return createElement("input", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormInput.displayName = "FormInput";
}
export {
  FormInput,
  useFormInput
};
